import { isLocalStorageAvailable } from '../../../utils';

const MUTATIONS = {
  TOGGLE_SIDEBAR(state) {
    state.sidebarActive = !state.sidebarActive;
  },
  TOGGLE_FAV_SIDEBAR(state) {
    state.favouritesSidebarActive = !state.favouritesSidebarActive;
  },
  CLOSE_FAV_SIDEBAR(state) {
    state.favouritesSidebarActive = false;
  },
  SET_INVESTMENT(state, investment) {
    state.currentInvestment = investment;
  },
  FETCHING_FLATS(state) {
    state.fetchingFlats = true;
  },
  FETCHED_FLATS(state) {
    state.fetchingFlats = false;
  },
  PUSH_FLATS(state, flats) {
    let flts = state.flats;
    let ids = flts.map(flat => flat[state.flatProperties['id']]);
    if (Array.isArray(flats)) {
      for (let i in flats) {
        if (ids.includes(flats[i][state.flatProperties['id']])) {
          flts.splice(ids.indexOf(flats[i][state.flatProperties['id']]), 1);
        }
      }
      state.flats = [...flts, ...flats];
    } else {
      if (ids.includes(flats[state.flatProperties['id']])) {
        flts.splice(ids.indexOf(flats[state.flatProperties['id']]), 1);
      }
      state.flats = [...flts, { ...flats }];
    }
  },
  CLEAR_FLATS(state) {
    state.flats = [];
  },
  SET_FAVOURITES(state, favs) {
    state.favourites = favs;
    if (isLocalStorageAvailable()) {
      localStorage.favourites = JSON.stringify(favs);
    }
  },
  ADD_TO_FAVOURITES(state, flats) {
    let favs,
      investmentURL = null,
      investmentAssets = null;
    if (state.currentInvestment) {
      investmentURL = state.currentInvestment.url;
      investmentAssets = state.currentInvestment.assetsDirectory;
    }
    let ids = state.favourites.map(fav => fav[state.flatProperties['id']]);
    if (Array.isArray(flats)) {
      for (let i in flats) {
        if (ids.includes(flats[i][state.flatProperties['id']])) {
          flats.splice(i, 1);
        }
      }
      favs = [
        ...state.favourites,
        ...flats.map(flat => ({
          investment: { assets: investmentAssets, url: investmentURL },
          ...flat,
        })),
      ];
    } else if (!ids.includes(flats[state.flatProperties['id']])) {
      favs = [
        ...state.favourites,
        {
          investment: { assets: investmentAssets, url: investmentURL },
          ...flats,
        },
      ];
    } else {
      return false;
    }
    state.favourites = favs;
    if (isLocalStorageAvailable()) {
      localStorage.favourites = JSON.stringify(favs);
    }
  },
  DELETE_FROM_FAVOURITES(state, flat) {
    let favs = state.favourites;
    favs = [
      ...favs.filter(
        fav =>
          fav[state.flatProperties['id']] != flat[state.flatProperties['id']]
      ),
    ];
    state.favourites = favs;
    if (isLocalStorageAvailable()) {
      localStorage.favourites = JSON.stringify(favs);
    }
  },
  CLEAR_FAVOURITES(state) {
    let favs = [];
    state.favourites = favs;
    if (isLocalStorageAvailable()) {
      localStorage.favourites = JSON.stringify(favs);
    }
  },
  FIND_IN_FAVOURITES(state, query) {
    state.favouritesQuery = query;
  },
  PRINT_ERROR(state, error) {
    state.errorMessage = error;
  },
  ADD_FILTERS(state, filters) {
    //[{ property, ?from, ?to, ?equal, ?contant = false },...]
    let newFilters = {
      constantFilters: [],
      filters: [],
    };

    if (!Array.isArray(filters)) {
      filters = [filters];
    }

    let arrays = ['constantFilters', 'filters'];

    for (let array of arrays) {
      let sfilters = [...state[array]];

      for (let filter of filters) {
        if (
          Number(filter.from) > Number(filter.to) &&
          filter.from &&
          filter.to
        ) {
          let temp = filter.to;
          filter.to = filter.from;
          filter.from = temp;
        }

        // Removing previous filters with same property as new one.
        for (let i in sfilters) {
          if (sfilters[i].property === filter.property) {
            sfilters.splice(i, 1);
          }
        }
        if (
          (array == 'constantFilters' && filter.constant) ||
          (array == 'filters' && !filter.constant)
        ) {
          newFilters[array].push({ ...filter });
        }
      }
      state[array] = [...sfilters, ...newFilters[array]];
    }
  },
  DELETE_FILTER(state, { property, constant = false }) {
    let array = constant == true ? 'constantFilters' : 'filters';
    let filters = state[array];
    // Removing filters with chosen property
    for (let i in filters) {
      if (filters[i].property === property) {
        filters.splice(i, 1);
      }
    }
    state[array] = [...filters];
  },
  CLEAR_FILTERS(state) {
    state.filters = [];
  },
  SET_SORTING_PROPERTY(state, property) {
    state.sorting.property = property;
  },
  SET_SORTING_ORDER(state, order) {
    state.sorting.order = order;
  },
};

export default MUTATIONS;
